import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Always use light theme - dark mode removed
  const theme = 'light';

  // Apply light theme immediately and always
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', 'light');
      // Clear any dark theme from localStorage
      localStorage.removeItem('trempi-theme');
    }
  }, []);

  // No-op functions for backward compatibility
  const setTheme = () => {}; // Do nothing
  const toggleTheme = () => {}; // Do nothing

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
